import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormGroupDirective,
} from '@angular/forms';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import {
  convertParseDateTime,
  extractDateTimeFromDateString,
} from 'src/app/shared/utils/utility.service';
import { MFValidators } from 'src/app/shared/validators/mf-validators';
import {
  IuserGroup,
  IUserGroupDetails,
  IUserProfile,
} from 'src/app/user-management/user-management-interfaces';
import { CONSTANTS } from 'src/app/shared/constants/constants';

@Component({
  selector: 'app-user-profile-groups-without-scheduler',
  templateUrl: './user-profile-groups-without-scheduler.component.html',
  styleUrls: ['./user-profile-groups-without-scheduler.component.scss'],
})
export class UserProfileGroupsWithoutSchedulerComponent implements OnInit {
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();
  @Input() profileDetails!: IUserProfile;
  @Output() profileDetailsChange = new EventEmitter<IUserProfile>();

  @Input() accessTimeFormGroupName!: string;
  @Input() selectedGroup!: IuserGroup;
  @Input() ownProfile!: boolean;
  @Input() deleteGroupFlag!: boolean;
  @Output() deleteGroupFlagChange = new EventEmitter<boolean>();
  userType!: string | undefined;

  @Input() userGroupList!: IUserGroupDetails[];
  @Output() userGroupListChange = new EventEmitter<IUserGroupDetails[]>();

  readonly LANG_CONST = LANG_CONST;
  readonly CONSTANTS = CONSTANTS;
  userAccessformGroup!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private rootFormGroup: FormGroupDirective
  ) { }

  ngOnInit(): void {
    this.userType = this.profileDetails?.userType;
    this.userAccessformGroup = this.rootFormGroup.control.get(
      this.accessTimeFormGroupName
    ) as FormGroup;
  }

  /**
   * @description close modal dialogue with help of material service
   * @returns void
   */
  closeDialog(): void {
    this.dialogRef?.close();
  }

  /**
   * @description navigate to back screen
   * @returns void
   */
  navigateBack(): void {
    this.stepperChange.emit((this.stepper = 1));
  }

  /**
   * @description add new control for form control
   * @param controlName control name for creation
   * @returns void
   */
  addNewControl(controlName: string, required = false): void {
    let dCtrl = new FormControl();
    if (required) {
      dCtrl.setValidators(MFValidators.required);
    }
    this.userAccessformGroup.addControl(controlName, dCtrl);
    dCtrl.updateValueAndValidity();
  }

  editGroup(selectedGroup: IUserGroupDetails) {
    this.userGroupList = this.userGroupList.map(group => {
      if (group.userGroupId === selectedGroup.userGroupId) {
        return {
          ...group,
          active: !selectedGroup.active
        };
      }
      return group;
    });
  
  }

  submitGroup(selectedUserGroups: IUserGroupDetails[]) {
    this.stepperChange.emit((this.stepper = 1));
    this.userGroupListChange.emit(selectedUserGroups);
  }
}
